<template>
  <SyncRestfulApi />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
